import { createPortal } from "react-dom";

/** Portal react-datepicker calendar to body so modals do not clip the picker. */
export function datePickerPopper({ children }) {
  if (typeof document === "undefined") {
    return children;
  }
  return createPortal(
    <div
      className="datepicker-portal"
      style={{
        position: "relative",
        zIndex: 100021,
        isolation: "isolate",
      }}
    >
      {children}
    </div>,
    document.body
  );
}

export default datePickerPopper;
